module.exports = __webpack_public_path__ + "assets/img/product-exam2.83203dbf.png";